import { DashboardOutlined } from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
const dashboardManagmentItems = () => {
  const icons = {
    DashboardOutlined,
  };

  const dashboardItems = {
    id: "group-dashboard",
    title: (
      <FormattedMessage id="Dashboard">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    type: "group",
    icon: icons.DashboardOutlined,
    // url: "/dashboard",
    children: [
      {
        id: "dashboard",
        title: <FormattedMessage id="Dashboard" />,
        type: "item",
        url: "/dashboard",
        icon: icons.DashboardOutlined,
        breadcrumbs: false,
      },
    ],
  };

  return dashboardItems;
};

export default dashboardManagmentItems;
